import React from 'react';
import NavigationBar from '../nav_bar/navigation_bar';
import Blogs from './blogs';

const BlogsPage = () => {
    return (
        <div className="blogs-page">
            <NavigationBar />

            <main className="blogs-main">
                <Blogs />
            </main>

        </div>
    );
};

export default BlogsPage;
